var lineBoxWidth = 24;
var cardMarginTop = 8;
var horizontalLineWidth = 2;
var borderWidth = 1;
var topLineHeight = 28;
var sizePaddingMap = {
    sm: 4,
    md: 6,
    lg: 8,
};
var calcPartialTopLine = function (isParentLastNode) { return ({
    top: "".concat(0 - cardMarginTop - borderWidth, "px"),
    left: "".concat((-1 * lineBoxWidth) / 2, "px"),
    width: "".concat(lineBoxWidth / 2, "px"),
    height: "".concat(topLineHeight, "px"),
    borderBottomLeftRadius: isParentLastNode ? 3 : 0,
}); };
var calcPartialBottomLine = function (cardHeight, cardPadding) { return ({
    bottom: "".concat(0 - borderWidth, "px"),
    left: "".concat((-1 * lineBoxWidth) / 2, "px"),
    width: "".concat(lineBoxWidth / 2, "px"),
    height: "".concat(cardHeight -
        (topLineHeight - cardPadding - horizontalLineWidth - borderWidth * 2), "px"),
}); };
var calcFullLine = function (cardHeight) { return ({
    bottom: "".concat(0 - borderWidth, "px"),
    left: "".concat((-1 * lineBoxWidth) / 2, "px"),
    width: "".concat(lineBoxWidth / 2, "px"),
    height: "".concat(cardHeight + cardMarginTop + borderWidth * 2, "px"),
}); };

export { borderWidth, calcFullLine, calcPartialBottomLine, calcPartialTopLine, cardMarginTop, horizontalLineWidth, lineBoxWidth, sizePaddingMap, topLineHeight };
//# sourceMappingURL=utils.js.map
